<template>
  <div class="ending" @click="goUrl">
    <div class="notice-img" v-if="ending.img">
      <img :src="ending.img">
    </div>
    <div class="notice" v-else>
      活动已结束，点此跳转到主网站
    </div>
  </div>
</template>

<script>

export default {
  name: 'ending',
  data () {
    return {
      ending: {
        img: '',
        url: 'https://www.xyxun.top'
      },
      screenHeight: ''
    }
  },
  created () {
    // WeixinJSBridge.call('showOptionMenu');
    this.screenHeight = window.screen.height
    this.getView()
  },
  methods: {
    goUrl () {
      location.href = this.ending.url
    },
    getView () {
      let that = this
      this.$g.ajax({
        path: 'eventEnds/getInfo',
        method: 'post',
        cbSuccess: function (data) {
          if (data.memo) {
            that.ending = {
              img: data.memo.img,
              url: data.memo.url
            }
          }
        },
        cbError: function (data) {
          that.$message.error(data.msg)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.ending{
  width: 100%;
  .notice-img{
    img{
      width: 100%
    }
  }
  .notice{
    margin: 20%;
    font-size: 14px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/end.vue